class GlideCarousel extends HTMLElement {
    constructor () {
        super();
        let id = this.getAttribute('id');
        let perView = this.getAttribute('perView');
        let perViewTablet = this.getAttribute('perViewTablet');
        let perViewMobile = this.getAttribute('perViewMobile');
        let glideType = this.getAttribute('glideType');
        let slideGap = this.getAttribute('slideGap');
        var autoplay = false;
        var focusAt = 'center';
        
        if(this.getAttribute('autoplay') != 'false') {
            autoplay = this.getAttribute('autoplaySeconds') * 1000;
        }

        /* For the focusAt attribute, we can either have a numerical value for the index or mark it as 'center'. 
-          Since we cannot smartly generate the list of indexes, 0 is our only safe choice.
-          See: https://glidejs.com/docs/options/#focusat */

        if(this.getAttribute('focusAt') == 'start') {
            focusAt = 0;
        }

        var peekLeft = this.getAttribute('peekLeft');
        var peekRight = this.getAttribute('peekRight');

        // Default set to 0 since some sections were designed with the thinking that peeks are set to 0 on mobile
        var peekLeftMobile = this.getAttribute('peekLeftMobile') || 0;
        var peekRightMobile = this.getAttribute('peekRightMobile') || 0;

        var glide = new Glide('#'+id, {
            type: glideType,
            focusAt: focusAt,
            perView: perView,
            gap: slideGap,
            autoplay: autoplay,
            hoverpause: true,
            peek: {
                before: peekLeft,
                after: peekRight
            },
            breakpoints: {
                1200: {
                  perView: perViewTablet,
                  focusAt: 0
                },
                768: {
                  perView: perViewMobile,
                  focusAt: 0,
                  peek: {
                    before: peekLeftMobile,
                    after: peekRightMobile
                  }
                },
                550: {
                    perView: 1
                }
            }
        });
        glide.mount();
    }
}

customElements.define('glide-carousel', GlideCarousel);